module.exports = __webpack_public_path__ + "static/media/gh_styles1.8dfacb80.jpg";